<template>
    <div>
    
        <div class="login_btn" v-if="!isLogin">
            <el-button type="danger" size="small" round @click="showLogin">{{ $t('login') }}</el-button>
        </div>
        <el-dropdown v-else class="u_btn" trigger="click">
            <div class="u_icon el-icon-user"></div>
            <el-dropdown-menu>
                <el-dropdown-item disabled>
                    <p style="margin: 0; line-height: 16px;">
                        {{ $t('roleName') }}{{ storage.roleName }}
                    </p>
                    <p v-if="storage.serverName" style="margin: 0; line-height: 16px;">
                        {{ $t('serverName') }}{{ storage.serverName }}
                    </p>
                </el-dropdown-item>
                <el-dropdown-item divided disabled>
                    <el-button plain round size="small" class="login-btn-item"
                        style="width:100%; border-radius: 4px; font-size: 10px;" @click="dialogCtrl">{{
                            $t('consumeRecord') }}</el-button>
                </el-dropdown-item>
                <!-- 礼金相关内容 密码，安全邮箱，重置密码-->
                <template v-if="showPointBtn">
                    <el-dropdown-item disabled v-if="!pwdFlag.isPasswordSet">
                        <el-button  class="login-btn-item" plain round size="small" @click="setPwdOrEmail('setPwd')"> {{ $t("setPayPwd")
                            }}</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item disabled v-else>
                        <el-button  class="login-btn-item" plain round size="small" @click="setPwdOrEmail('changePwd')"> {{ $t("changePayPwd")
                            }}</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item disabled v-if="!emailFlag.isEmailSet">
                        <el-button  class="login-btn-item" plain round size="small" @click="setPwdOrEmail('setEmail')"> {{ $t("toSetEmail")
                            }}</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item disabled v-else>
                        <el-button  class="login-btn-item" plain round size="small" @click="setPwdOrEmail('showEmail')"> {{ $t("checkEmail")
                            }}</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item disabled v-if="emailFlag.isEmailSet && pwdFlag.isPasswordSet">
                        <el-button  class="login-btn-item" plain round size="small" @click="setPwdOrEmail('forgetPwd')"> {{ $t("forgetPayPwd")
                            }}</el-button>
                    </el-dropdown-item>
                </template>
                <el-dropdown-item divided disabled v-if="roleData&&roleData.length > 1">
                    <p class="role-name-item" @click="setRoleDialog">{{ $t('roleChange') }}</p>
                </el-dropdown-item>
                <el-dropdown-item disabled>
                    <p class="role-name-item" @click="logout">{{ $t('logout') }}</p>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <PointPayDialog v-if="isLogin&&refreshRouter"  ref="pointPayDialog"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PointPayDialog from './PointPayDialog.vue';
export default {
    name: '',
    components: {PointPayDialog},
    props: {
        storage: {
            type: Object,
            default: () => {
                return {}
            }
        },
        roleData: {
            type: Array,
            default: () => {
                return []
            }
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        refreshRouter:{
            type: Boolean,
            default: true
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters(["pwdFlag", "emailFlag", "uwLoading", "pointSwitch",]),
        // 显示礼金支付相关内容
        showPointBtn() {
            if (this.uwLoading === 'loaded') {
                if (typeof this.pointSwitch !== "string") {
                    return this.pointSwitch.ruleSwitch&&this.pointSwitch.ruleSwitch.quantityDisplay?true:false
                }
            }
            return false;
        }
    },
    mounted() { },
    methods: {
        // 消费记录弹窗
        dialogCtrl() {
            this.$emit('dialogCtrl')

        },
        // 角色切换弹窗
        setRoleDialog() {
            this.$emit('setRoleDialog')
        },
        // 退出登录
        logout() {
            this.$emit('logout')
        },
        // 登录弹窗
        showLogin() {
            this.$emit('showLogin')
        },
        // 支付密码与安全邮箱
        setPwdOrEmail(status) {
            this.$refs.pointPayDialog.showDialog(status);
        },
       
        
    },
}

</script>
<style lang='scss' scoped>
.role-name-item {
    margin: 5px 0;
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    color: #606266;
    cursor: pointer;
}

.login-btn-item {
    width: 100%;
    border-radius: 4px;
    font-size: 10px;
}
.login_btn{
      // float: right;
    }
    .u_btn{
      // float: right;
      .u_icon{
        width: 30px;
        height: 30px;
        background-color: #fff;
        border-radius: 15px;
        font-size: 20px;
        line-height: 30px;
      }
    }
</style>
